import React, { useContext } from "react";
import { Box } from "@mui/material";
import ProductsContainer from "../Products/ProductsContainer";
import RecentlyViewedContext from "../../../context/recentlyViewed/RecentlyViewedContext";
import AllProductsContext from "../../../context/allProducts/AllProductsContext";
import LikedItemsContext from "../../../context/likedItems/LikedItemsContext";

const MoreProducts = ({
  showLiked = false,
  showAll = false,
  showRecentlyViewed = false,
}) => {
  const recentlyViewedContext = useContext(RecentlyViewedContext);
  const allProductsContext = useContext(AllProductsContext);
  const likedItemsContext = useContext(LikedItemsContext);
  return (
    <>
      {showLiked && likedItemsContext.state.length > 0 && (
        <Box className="store-row">
          <Box className="store-row-heading">
            <div>
              <p className="store-eyebrow">Saved</p>
              <h2>Your wishlist</h2>
            </div>
          </Box>
          <ProductsContainer
            heading=""
            showLikeButton={true}
            showInRow={true}
            addToCartEnable={true}
            showCarousel={false}
            showScrollButtons={true}
            productsArray={likedItemsContext.state}
          />
        </Box>
      )}
      {showRecentlyViewed && recentlyViewedContext.state.length > 0 && (
        <Box className="store-row">
          <Box className="store-row-heading">
            <div>
              <p className="store-eyebrow">Pick up where you left</p>
              <h2>Recently viewed</h2>
            </div>
          </Box>
          <ProductsContainer
            heading=""
            showInRow={true}
            addToCartEnable={true}
            showCarousel={false}
            showScrollButtons={true}
            productsArray={recentlyViewedContext.state}
          />
        </Box>
      )}
      {showAll && (
        <Box className="store-row">
          <Box className="store-row-heading">
            <div>
              <p className="store-eyebrow">More to explore</p>
              <h2>Consider these products</h2>
            </div>
          </Box>
          <ProductsContainer
            heading=""
            showInRow={true}
            addToCartEnable={true}
            showCarousel={false}
            showScrollButtons={true}
            productsArray={allProductsContext.state}
          />
        </Box>
      )}
    </>
  );
};

export default MoreProducts;
